import { db } from '../firebase'

  const publishOrderSyncRequest = (orderNumber, transporterId) => {
    const odooSyncPayload = {
            entity: 'ORDER',
            order_number: orderNumber,
            transporter_id: transporterId
    }
    db.ref('odooSync').push().set(odooSyncPayload)
  }

  export {publishOrderSyncRequest}
